import { EvaluationCriteriaItemForm } from '@/module/Evaluation/form/EvaluationCriteriaItemForm';
import { useEvaluationEditCriteriaItem } from '@/module/Evaluation/model/EvaluationQuery';
import {
  EvaluationCriteriaDataItem,
  EvaluationCriteriaDataItemRequest,
  EvaluationCriteriaDiscriminator,
  EvaluationCriteriaType,
} from '@/module/Evaluation/model/EvaluationTypes';

import { Id, useAppNotification } from '@feature/utils';

interface EvaluationCriteriaItemEditProps {
  close: () => void;
  discriminatorList: EvaluationCriteriaDiscriminator[];

  evaluationId: Id;
  authorId: Id;
  orderNo: number;

  editItem: EvaluationCriteriaDataItem;
  criteriaType: EvaluationCriteriaType;

  dataEntryHint: string | null;

  alreadySelectedIds: number[];
}

export function EvaluationCriteriaItemEdit(props: EvaluationCriteriaItemEditProps) {
  const {
    close,
    evaluationId,
    authorId,
    orderNo,
    discriminatorList,
    editItem,
    criteriaType,
    dataEntryHint,
    alreadySelectedIds,
  } = props;
  const { mutate, isPending } = useEvaluationEditCriteriaItem(evaluationId, authorId, orderNo, editItem.id);
  const notification = useAppNotification();
  const onSubmit = (values: EvaluationCriteriaDataItemRequest) => {
    mutate(
      {
        ...values,
        criteriaType,
      },
      {
        onSuccess: () => {
          notification.success();
          close();
        },
        onError: notification.error,
      },
    );
  };
  return (
    <EvaluationCriteriaItemForm
      onCancel={close}
      onSubmit={onSubmit}
      isSubmitting={isPending}
      defaultValues={{
        ...editItem,
        discriminatorCode: editItem.discriminator?.code,
      }}
      criteriaType={criteriaType}
      discriminatorList={discriminatorList}
      dataEntryHint={dataEntryHint}
      evaluationId={evaluationId}
      authorId={authorId}
      orderNo={orderNo}
      alreadySelectedIds={alreadySelectedIds}
    />
  );
}
